<div class="content-container">
	<div class="content">
		<h3 *ngIf="!err" class="center-text">One Moment...</h3>
		<h3 *ngIf="err" class="error-message">{{err}}</h3>
	</div>
</div>
